'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectValues = require('object-values');

var _objectValues2 = _interopRequireDefault(_objectValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TextAlign = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center'
};

var propTypes = exports.propTypes = {
  textAlign: _propTypes2.default.oneOf((0, _objectValues2.default)(TextAlign))
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var textAlign = _ref.textAlign,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['textAlign', 'style']);

  var styles = {};

  styles.textAlign = textAlign;

  return _extends({ style: _extends({}, styles, style) }, props);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvdGV4dEFsaWduLmpzIl0sIm5hbWVzIjpbIlRleHRBbGlnbiIsIkxFRlQiLCJSSUdIVCIsIkNFTlRFUiIsInByb3BUeXBlcyIsInRleHRBbGlnbiIsIm9uZU9mIiwicGFyc2VQcm9wcyIsInN0eWxlIiwicHJvcHMiLCJzdHlsZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7Ozs7O0FBRUEsSUFBTUEsWUFBWTtBQUNoQkMsUUFBTSxNQURVO0FBRWhCQyxTQUFPLE9BRlM7QUFHaEJDLFVBQVE7QUFIUSxDQUFsQjs7QUFNTyxJQUFNQyxnQ0FBWTtBQUN2QkMsYUFBVyxvQkFBVUMsS0FBVixDQUFnQiw0QkFBYU4sU0FBYixDQUFoQjtBQURZLENBQWxCOztBQUlBLElBQU1PLGtDQUFhLFNBQWJBLFVBQWEsT0FJcEI7QUFBQSxNQUhKRixTQUdJLFFBSEpBLFNBR0k7QUFBQSxNQUZKRyxLQUVJLFFBRkpBLEtBRUk7QUFBQSxNQUREQyxLQUNDOztBQUNKLE1BQU1DLFNBQVMsRUFBZjs7QUFFQUEsU0FBT0wsU0FBUCxHQUFtQkEsU0FBbkI7O0FBRUEsb0JBQVNHLG9CQUFZRSxNQUFaLEVBQXVCRixLQUF2QixDQUFULElBQTRDQyxLQUE1QztBQUNELENBVk0iLCJmaWxlIjoidGV4dEFsaWduLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IG9iamVjdFZhbHVlcyBmcm9tICdvYmplY3QtdmFsdWVzJ1xuXG5jb25zdCBUZXh0QWxpZ24gPSB7XG4gIExFRlQ6ICdsZWZ0JyxcbiAgUklHSFQ6ICdyaWdodCcsXG4gIENFTlRFUjogJ2NlbnRlcidcbn1cblxuZXhwb3J0IGNvbnN0IHByb3BUeXBlcyA9IHtcbiAgdGV4dEFsaWduOiBQcm9wVHlwZXMub25lT2Yob2JqZWN0VmFsdWVzKFRleHRBbGlnbikpXG59XG5cbmV4cG9ydCBjb25zdCBwYXJzZVByb3BzID0gKHtcbiAgdGV4dEFsaWduLFxuICBzdHlsZSxcbiAgLi4ucHJvcHNcbn0pID0+IHtcbiAgY29uc3Qgc3R5bGVzID0ge31cblxuICBzdHlsZXMudGV4dEFsaWduID0gdGV4dEFsaWduXG5cbiAgcmV0dXJuIHsgc3R5bGU6IHsgLi4uc3R5bGVzLCAuLi5zdHlsZSB9LCAuLi5wcm9wcyB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/textAlign.js
// module id = 1152
// module chunks = 0